import LoginPage from '../pages/LoginPage';
import LoginEntryPage from '../pages/LoginEntryPage';
import SignupPage from '../pages/SignupPage';
import ForgotPage from '../pages/ForgotPage';
import OtpPage from '../pages/OtpPage';
import Page404 from '../pages/Page404';

// Phase 5: Public-only route table (no auth required).
export const publicRoutes = [
  {
    path: 'signup/:email',
    element: <SignupPage />,
  },
  {
    path: 'login',
    element: <LoginEntryPage />,
  },
  {
    path: 'login/:email',
    element: <LoginPage />,
  },
  {
    path: 'forgot/:email',
    element: <ForgotPage />,
  },
  {
    path: 'otp/:email',
    element: <OtpPage />,
  },
  {
    path: '*',
    element: <Page404 />,
  },
];
